// Adds the clicked product variant to the cart via /cart/add.js,
// then refreshes the cart drawer and opens it.
// Bound once via event delegation so it works on dynamically-injected cards.
// Also includes:
//   - Cart-drawer "Remove" button fallback handler (calls /cart/change.js).
//   - Cart-drawer subscription pill dropdown — toggling open/close + plan changes.

(function () {
  if (window.__productCardAddBound) return;
  window.__productCardAddBound = true;

  // Set a one-shot flag on <cart-drawer> right before any user action that
  // should open the drawer. cart-drawer.js's renderContents() only calls
  // open() when this flag is set (or the drawer is already open), which
  // prevents app embeds that fetch /cart on page load from auto-opening it.
  function flagCartOpen() {
    var cd = document.querySelector('cart-drawer');
    if (cd) cd.dataset.forceOpenNext = '1';
  }

  // Any product-form submit (the main ATC button) → open the drawer
  // after the add completes.
  document.addEventListener('submit', function (event) {
    if (event.isTrusted === false) return;
    if (event.target.closest('product-form')) flagCartOpen();
  }, true);

  // ── Cart subscription pill ──
  // Two states share one POST helper:
  //   - <button data-subscription-subscribe> click → subscribe to default plan.
  //   - <select data-subscription-select> change → switch plan or unsubscribe.
  function changeLineSellingPlan(wrap, planId, controlEl) {
    var lineIndex = wrap.dataset.lineIndex;
    var cartDrawer = document.querySelector('cart-drawer');
    var sections = [];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
    }

    var body = {
      line: parseInt(lineIndex, 10),
      selling_plan: planId || null,
      sections: sections.join(','),
      sections_url: window.location.pathname
    };

    if (controlEl) controlEl.disabled = true;

    fetch((window.routes && window.routes.cart_change_url) || '/cart/change', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && response.sections) {
          cartDrawer.renderContents(response);
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        if (controlEl) controlEl.disabled = false;
        console.error('[cart-subscription] error:', err);
      });
  }

  // Select change → switch / unsubscribe
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-subscription-select]');
    if (!select) return;
    // Guard: only act when the change is a genuine user interaction AND the
    // cart drawer is actually open. Browser form-state restoration / DOM
    // hydration after innerHTML replacement can fire synthetic `change`
    // events on page load, which would call /cart/change → renderContents
    // → auto-open the cart drawer 1–2s after every page load.
    if (event.isTrusted === false) return;
    var openDrawer = document.querySelector('cart-drawer.active');
    if (!openDrawer) return;
    var wrap = select.closest('.cart-item__subscription');
    if (!wrap) return;
    // Show a loading pill over the select while the cart updates. The
    // entire wrapper gets re-rendered by changeLineSellingPlan's response
    // so we don't need to clean up — the class disappears on its own.
    var isUnsubscribe = select.value === '';
    var loadingText = isUnsubscribe ? 'Unsubscribing…' : 'Switching…';
    wrap.setAttribute('data-loading-text', loadingText);
    wrap.classList.add('cart-item__subscription--loading');
    // Unsubscribing previews the post-action state by adopting the same
    // dark-filled style as the "Subscribe & Save" button (which is what
    // the user lands on once they're no longer subscribed).
    if (isUnsubscribe) wrap.classList.add('cart-item__subscription--loading-unsubscribe');
    changeLineSellingPlan(wrap, select.value, select);
  });

  // Button click → subscribe to the default (best) plan
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-subscription-subscribe]');
    if (!btn) return;
    // Same guards as above — never act on synthetic clicks or when the
    // cart isn't open.
    if (event.isTrusted === false) return;
    var openDrawer = document.querySelector('cart-drawer.active');
    if (!openDrawer) return;
    event.preventDefault();
    var wrap = btn.closest('.cart-item__subscription');
    if (!wrap) return;
    var planId = btn.getAttribute('data-default-plan-id');
    if (!planId) return;
    // Swap the button label to a loading state. The wrapper re-renders
    // on response so we just mutate text/state and don't restore.
    btn.textContent = 'Subscribing…';
    btn.disabled = true;
    changeLineSellingPlan(wrap, planId, btn);
  });

  // ── Cart-drawer Remove (trash button) ──
  // Catches the click on the trash icon inside <cart-remove-button>, then
  // posts {line, quantity: 0} to /cart/change.js and refreshes the cart drawer.
  // Independent of Dawn's <cart-remove-button> custom element so it works even
  // if Dawn's JS errored out during page load.
  document.addEventListener('click', function (event) {
    if (event.isTrusted === false) return;
    var clickedRemove = event.target.closest('.cart-remove-link');
    if (!clickedRemove) return;
    var removeWrap = clickedRemove.closest('cart-remove-button');
    if (!removeWrap) return;
    var line = removeWrap.getAttribute('data-index');
    if (!line) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    if (clickedRemove.dataset.removing === '1') return;
    clickedRemove.dataset.removing = '1';

    var cartDrawer = document.querySelector('cart-drawer');
    var sectionIds = [];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sectionIds = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        line: parseInt(line, 10),
        quantity: 0,
        sections: sectionIds,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        clickedRemove.dataset.removing = '';
        if (!cartDrawer) { window.location.reload(); return; }
        if (response.item_count === 0) cartDrawer.classList.add('is-empty');
        else cartDrawer.classList.remove('is-empty');
        if (typeof cartDrawer.renderContents === 'function' && response.sections) {
          cartDrawer.renderContents(response);
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        clickedRemove.dataset.removing = '';
        console.error('[cart-remove] error:', err);
      });
  }, true); // capture phase — runs before Dawn's <cart-remove-button> handler


  document.addEventListener('click', function (event) {
    if (event.isTrusted === false) return;
    var btn = event.target.closest('[data-product-card-add]');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    if (btn.dataset.loading === '1') return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var cartDrawer = document.querySelector('cart-drawer');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      var ids = cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      formData.append('sections', ids);
      formData.append('sections_url', window.location.pathname);
      if (typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(document.activeElement);
      }
    }

    btn.dataset.loading = '1';
    btn.setAttribute('aria-disabled', 'true');
    flagCartOpen();

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        btn.dataset.loading = '';
        btn.removeAttribute('aria-disabled');

        if (response.status) {
          // 422 etc. — cart add failed (out of stock, etc.)
          console.warn('[product-card] add failed:', response.description || response.message);
          return;
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          // Strip `is-empty` from the outer <cart-drawer> so the items table
          // (which is `display: none` when is-empty is present) becomes visible.
          // Dawn's renderContents only handles is-empty on .drawer__inner.
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(response);
        } else {
          // No cart drawer on page — just reload to reflect the new cart.
          window.location.reload();
        }
      })
      .catch(function (err) {
        btn.dataset.loading = '';
        btn.removeAttribute('aria-disabled');
        console.error('[product-card] add error:', err);
      });
  }, true);
})();
